import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { isDetour, isReleased } from './detour';

/**
 * Режим фокуса первого запуска (облако): пока мастер не завершён и не пропущен,
 * администратор склада видит только мастер. Решение принимает Layout:
 *
 * - обычный переход на любой экран → в мастер (/setup), меню не рисуется;
 * - переход из самого мастера (ссылка «Загрузить из Excel», «Все реквизиты»…) →
 *   экран открывается, сверху полоска «Вернуться к настройке склада»;
 * - справка (/knowledge) и профиль открываются всегда — на справку ведут шаги.
 *
 * Full-Fix и склад без мастера: сервер отвечает enabled=false / focus=false —
 * ничего не делаем. Статус спрашивают только у администратора склада облака.
 */
const FREE_PATHS = ['/knowledge', '/profile', '/setup'];
// В мастер уводим только с «домашних» адресов (куда попадают после входа). Прямая
// ссылка на экран (закладка, ссылка из Telegram, письма) открывает экран с полоской
// «Вернуться к настройке» — проход 28.09: первый переход на «Отгрузки» за сессию
// перекидывал в /setup даже после «Пропустить»/«Завершить».
const LANDING = ['/', '/processing', '/start'];

/** 'redirect' — увести в мастер, 'detour' — показать полоску возврата, null — ничего */
export function setupFocusMode(st, location) {
  if (!st || !st.enabled || !st.focus || isReleased()) return null;
  const free = FREE_PATHS.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));
  if (free) return null;
  if (location.state?.fromSetup || isDetour()) return 'detour';
  return LANDING.includes(location.pathname) ? 'redirect' : 'detour';
}

export function SetupDetourBanner() {
  return (
    <div className="sw-detour" role="note">
      <span>Вы в настройке склада. Закончите здесь и возвращайтесь — прогресс сохранён.</span>
      <Link to="/setup" className="ui-btn ui-btn--primary ui-btn--sm"><ArrowLeft size={14} aria-hidden="true" /> Вернуться к настройке</Link>
    </div>
  );
}
